import { render, staticRenderFns } from "./EditGalleryEvent.vue?vue&type=template&id=5efd8d60&scoped=true&"
import script from "./EditGalleryEvent.vue?vue&type=script&lang=js&"
export * from "./EditGalleryEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efd8d60",
  null
  
)

export default component.exports